const LOAD_LAYOUTS = "LOAD_LAYOUTS";

const SET_LINK = "SET_LINK";

const LOAD_LAYOUT = "LOAD_LAYOUT";

const UPDATE_HISTORY = "UPDATE_HISTORY";
const UPDATE_PARAMS = "UPDATE_PARAMS";

const LOAD_CREDENTIALS = "LOAD_CREDENTIALS";

const CLEAN_LAYOUT = "CLEAN_LAYOUT";

const LOAD_LAYOUTS_FAIL = "LOAD_LAYOUTS_FAIL";
const LOAD_LAYOUTS_SUCCESS = "LOAD_LAYOUTS_SUCCESS";
const LOAD_LAYOUT_FAIL = "LOAD_LAYOUT_FAIL";

const LOAD_LAYOUT_SUCCESS = "LOAD_LAYOUT_SUCCESS";
const LOAD_CREDENTIALS_SUCCESS = "LOAD_CREDENTIALS_SUCCESS";

const LOAD_CREDENTIALS_FAIL = "LOAD_CREDENTIALS_FAIL";

const CLEAN_HISTORY_LOADED = "CLEAN_HISTORY_LOADED";

const HISTORY_LOADED = "HISTORY_LOADED";

const LAYOUT_POST = "LAYOUT_POST";
const LAYOUT_DELETE = "LAYOUT_DELETE";

const RESET_HISTORY = "RESET_HISTORY";

const RESET_LAYOUT_SELECTED = "RESET_LAYOUT_SELECTED";

export default function layout(
  state = {
    dataLayout: [],
    layoutSelected: {},
    history: {},
    isLoading: true,
    hasErrored: false,
    message: "",
    credentialsUrl: null,
    historyLoaded: false,
  },
  action,
) {
  switch (action.type) {
    case LOAD_LAYOUTS: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case LOAD_LAYOUTS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case LOAD_LAYOUTS_SUCCESS: {
      return Object.assign({}, state, {
        dataLayout: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }

    case LOAD_LAYOUT: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
        historyLoaded: false,
      });
    }

    case LOAD_LAYOUT_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case LOAD_LAYOUT_SUCCESS: {
      return Object.assign({}, state, {
        layoutSelected: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }

    case SET_LINK: {
      return Object.assign({}, state, {
        layoutSelected: {
          ...state.layoutSelected,
          url: action.payload,
        },
      });
    }

    case UPDATE_HISTORY: {
      return {
        ...state,
        history: {
          ...state.history,
          ...action.payload,
        },
        historyLoaded: true,
      };
    }

    case CLEAN_HISTORY_LOADED: {
      return {
        ...state,
        historyLoaded: false,
      };
    }

    case UPDATE_PARAMS: {
      return Object.assign({}, state, {
        layoutSelected: {
          ...state.layoutSelected,
          params: {
            ...state.layoutSelected.params,
            ...action.payload,
          },
        },
      });
    }

    case LOAD_CREDENTIALS: {
      return Object.assign({}, state, {
        // isLoading: true,
        hasErrored: false,
      });
    }

    case LOAD_CREDENTIALS_SUCCESS: {
      return Object.assign({}, state, {
        // isLoading: false,
        credentialsUrl: action.payload.data,
      });
    }

    case LOAD_CREDENTIALS_FAIL: {
      return Object.assign({}, state, {
        // isLoading: false,
        hasErrored: true,
      });
    }

    case CLEAN_LAYOUT: {
      return Object.assign({}, state, {
        dataFilterValue: [],
      });
    }

    case RESET_HISTORY: {
      return {
        ...state,
        historyLoaded: false,
        history: {},
      };
    }

    case HISTORY_LOADED: {
      return {
        ...state,
        historyLoaded: true,
      };
    }

    case RESET_LAYOUT_SELECTED: {
      return {
        ...state,
        layoutSelected: {},
      };
    }

    default:
      return state;
  }
}

export function getLayouts() {
  return {
    type: LOAD_LAYOUTS,
    payload: {
      request: {
        url: "Layout",
      },
    },
  };
}

export function getCredentials() {
  return {
    type: LOAD_CREDENTIALS,
    payload: {
      request: {
        url: "Auth/MicroStrategy",
      },
    },
  };
}

export function getLayoutById(id) {
  return {
    type: LOAD_LAYOUT,
    payload: {
      request: {
        url: "LayoutFilter/Layout/" + id,
      },
    },
  };
}

export function addOrEditLayout(layout) {
  return {
    type: LAYOUT_POST,
    payload: {
      request: {
        url: "Layout",
        method: "POST",
        data: layout,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getLayouts());
        },
      },
    },
  };
}
export function deleteLayout(id) {
  return {
    type: LAYOUT_DELETE,
    payload: {
      request: {
        url: "Layout/" + id,
        method: "DELETE",
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getLayouts());
        },
      },
    },
  };
}

export function setLink(url) {
  return {
    type: SET_LINK,
    payload: url,
  };
}

export function updateHistory(element) {
  return {
    type: UPDATE_HISTORY,
    payload: element,
  };
}

export function clearFilterValueTable() {
  return {
    type: CLEAN_LAYOUT,
  };
}

export function updateParams(element) {
  return {
    type: UPDATE_PARAMS,
    payload: element,
  };
}

export function cleanHistoryLoaded() {
  return {
    type: CLEAN_HISTORY_LOADED,
  };
}

export function setHistoryLoaded() {
  return {
    type: HISTORY_LOADED,
  };
}

export function resetHistory() {
  return {
    type: RESET_HISTORY,
  };
}

export function resetLayout() {
  return {
    type: RESET_LAYOUT_SELECTED,
  };
}
